import React from "react";
import { useLang } from "./i18n";

export const ROLE_LABELS = {
  field_epi: "Épidémiologiste de Terrain",
  lab_tech: "Technicien de Laboratoire",
  rcce_agent: "Agent CREC / RCCE",
  eds_agent: "Agent EDS / SDB",
  ipc_agent: "Agent PCI",
  case_mgmt_agent: "Agent Prise en Charge",
  provincial_supervisor: "Superviseur Provincial",
  si_analyst: "Analyste SI",
  program_manager: "Gestionnaire de Programme",
  admin: "Administrateur",
};

export const CHART_COLORS = ["#F05A28", "#1E293B", "#0284C7", "#059669", "#D97706", "#7C3AED", "#E11D48", "#475569"];

export const pct = (v) => (v === null || v === undefined ? "N/A" : `${v}%`);
export const num = (v) => (v === null || v === undefined ? "N/A" : v.toLocaleString("fr-FR"));

export function KpiCard({ label, value, sub, icon: Icon, tone = "primary", testid }) {
  const { t } = useLang();
  const tones = {
    primary: "text-[#F05A28]",
    teal: "text-[#0284C7]",
    amber: "text-[#B45309]",
    red: "text-[#B91C1C]",
    slate: "text-slate-400",
  };
  return (
    <div data-testid={testid} className="bg-white p-4 rounded-lg border border-slate-200 shadow-sm hover:border-slate-300 transition-colors">
      <div className="flex items-start justify-between gap-3">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{t(label)}</p>
        {Icon && <Icon className={`h-4 w-4 shrink-0 ${tones[tone]}`} />}
      </div>
      <p className="text-2xl font-semibold text-slate-900 mt-2 tracking-tight tnum">{value}</p>
      {sub && <p className="text-xs text-slate-500 mt-1">{sub}</p>}
    </div>
  );
}

export function PageHeader({ title, subtitle, eyebrow, children, testid }) {
  const { t } = useLang();
  const meta = subtitle || eyebrow;
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 pb-4 mb-5 border-b border-slate-200" data-testid={testid}>
      <div>
        <h1 className="text-xl font-semibold tracking-tight text-slate-900">{t(title)}</h1>
        {meta && <p className="text-sm text-slate-500 mt-1 max-w-3xl">{t(meta)}</p>}
      </div>
      {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
    </div>
  );
}

const STATUS_STYLES = {
  submitted: "bg-blue-50 text-blue-700 border-blue-200",
  validated: "bg-emerald-50 text-emerald-700 border-emerald-200",
  flagged: "bg-red-50 text-red-700 border-red-200",
  Nouvelle: "bg-slate-100 text-slate-700 border-slate-200",
  "En revue": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "En cours": "bg-amber-50 text-amber-700 border-amber-200",
  "Résolue": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Clôturée": "bg-slate-100 text-slate-500 border-slate-200",
  Critique: "bg-red-50 text-red-700 border-red-200",
  "Élevée": "bg-amber-50 text-amber-700 border-amber-200",
  Moyenne: "bg-blue-50 text-blue-700 border-blue-200",
  Basse: "bg-slate-100 text-slate-600 border-slate-200",
  Urgent: "bg-red-50 text-red-700 border-red-200",
  Important: "bg-amber-50 text-amber-700 border-amber-200",
  "À surveiller": "bg-blue-50 text-blue-700 border-blue-200",
  Informatif: "bg-slate-100 text-slate-600 border-slate-200",
};
const STATUS_FR = { submitted: "Soumis", validated: "Validé", flagged: "Signalé" };

export function StatusBadge({ status }) {
  const { t } = useLang();
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${cls}`}>
      {t(STATUS_FR[status] || status)}
    </span>
  );
}
